import React from "react";
import { useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
// import { formatPathname } from "utils/helperFunctions";
import {
    Stack,
    IStackStyles,
    //TextField,
    Link
} from "@fluentui/react";
import {
    PrimaryButton
} from "@fluentui/react";
import {
    //useDispatch,
    useSelector
} from "react-redux";
import { AppState } from "store/index";
import {
    getModulePermissions,
    isUserMaster,
} from "utils/permissions/permissionsHelpers";
//import { emplyeePermissionsAction } from "../../constants/constants";
import { useDispatch } from "react-redux";
import { EditMoreActionsSubmenu } from "components/table/dropdowns/EditMoreActionsSubmenu";
//import CustomTable from "components/table/datatable/CustomTable";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CustomFontText } from "components/customFontText/CustomFontText";
//import { handleGetAppointments } from "store/dealTracker/dealTracker.action";
import { handleGetAppointmentList } from "store/dealTracker/dealTracker.action";
import { handleGetLocations } from "store/locations/locations.action";
//import moment from "moment";
import { isKarlProfile } from "utils/permissions/permissionsHelpers";
import {
    convertUTCToLocalDateOnlyModified,
    // convertUTCToLocalFormat
    // convertUTCToLocalMoment
} from "utils/dateTimeFunctions";
import { useNavigate , useLocation } from "react-router-dom";
import masterDropdownValues from "../../constants/masterDropdownValues";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { Paginator } from 'primereact/paginator';
import { DebounceInput } from 'react-debounce-input';

const container: IStackStyles = {
    root: {
        marginTop: 10,
    },
};

const credentialModuleName = "DealTracker";
export const AppointmentWorkbookV2Page = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const serverError = useSelector((state: AppState) => state.dealTracker.error) as any;
    //const [appointmentId, setAppointmentId] = useState(0);
    const [appointmentData, setAppointmentData] = useState(null);
    const [commonServerError, setcommonServerError] = useState(null);
    const user = useSelector((state: AppState) => state.userProfile.userProfile) as any;
    const navigate = useNavigate ();
    const [cityDealerList, setCityDealerList] = React.useState([0]);
	const locations = useSelector((state: AppState) => state.locations.locations) as any; 
	const isMobile = useMediaQuery({ maxWidth:960 });
    const yearRange = "1980:" + (new Date().getFullYear()+1);

    const isKarlProfileType = user.profileType && isKarlProfile(user.profileType);

    const [credentials, setCredentials] = useState([]);

    const [search, setGLFilter] = useState(null);
    const [locationFilter, setLocationFilter] = useState(0);
    const todaydate =  new Date().toLocaleDateString('en-US', {year: '2-digit', month: '2-digit', day: '2-digit'})
    const [logDateFromFilter, setLogDateFromFilter] = React.useState<Date | undefined>(undefined);
    const [logDateToFilter, setlogDateToFilter] = React.useState<Date | undefined>(undefined);
    const [primaryLocation, setPrimaryLocation] = useState(0);
    const [sortOrder, setSortOrder] = useState(null);
    const [sortField, setSortField] = useState('appointmentTime');
    const [statesFlag, setStatesFlag] = useState(false);
    const [userProfileLoadingFlag, setUserProfileLoadingFlag] = useState(false);
    const [totalRecords, setTotalRecords] = useState(null);
    const [pages, setPages] = useState(1);
    const [limit, setLimit] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [statePageNumber, setStatePageNumber] = useState(1);


    const handleSearchChange = (event: any) => {

        const inputValue = event.target.value.trim();
        if (inputValue !== '') {
            setGLFilter(inputValue);
        }
        if(event.target.value === ''){
             setGLFilter('');
        }
    };


	const onLocationChange = (e: { value: any }) => {
        setLocationFilter(e.value);

    }


    const handleFromLogDateChange = (val: any) => {
        setLogDateFromFilter(val.target.value)

    };

    const handleToLogDateChange = (val: any) => {
        setlogDateToFilter  (val.target.value)

    };

    useEffect(() => {

        if (locations && locations.results) {
        locations.results.unshift({ id: 0 ,legalName: 'All'});
            setCityDealerList(locations.results);
        } else {
            setCityDealerList(locations);
        }
     //console.log('locationslocationslocations',locations)   
    }, [locations]);

    useEffect(() => {

      
        if (user && user.roles) {
            setUserProfileLoadingFlag(true)
            if (user.roles.some(item => item === "ROLE_EMPLOYEE") && user.primaryLocationId) {
                setPrimaryLocation(user.primaryLocationId);
                setLocationFilter(user.primaryLocationId);
            }
        }
    }, [user]);// eslint-disable-line react-hooks/exhaustive-deps



    const handlePopulateAppointments = (appointments) => {
	        if (appointments.length){
	        	for (var i in appointments) {
                    let deal = appointments[i].deal;
                    let customer = deal.customer;
                    let hiddenStr = '';
                    
                    appointments[i]["appointmentTime"] = moment(appointments[i].appointmentTime).local().format('MM/DD/YY hh:mm a');
                    appointments[i]["appointDate"] = convertUTCToLocalDateOnlyModified(appointments[i].appointmentDate);
                    appointments[i]["dealNumber"] = deal.dealNumber;
                    appointments[i]["customer"] = customer.businessName ? customer.businessName:(customer.firstName + ' ' + customer.lastName);
                    appointments[i]["customerEmail"] = customer.email;
                    appointments[i]["customerPhone"] = customer.phoneNumber;
                    appointments[i]["confirmedBy"] = appointments[i].employee ? appointments[i].employee.firstName + ' ' + appointments[i].employee.lastName : '';
                    appointments[i]["salesPerson1"] = getSalesPerson(deal.salesPerson1);
                    appointments[i]["appointmentResult"] = appointments[i].appointmentResult ? getResult(appointments[i].appointmentResult) : '';
                
                    if (deal.vehicle)
                        hiddenStr = deal.vehicle?.orderNumber + ' ' + deal.vehicle?.stockNumber + ' ' + deal.vehicle?.vin;
                    if (deal.salesPerson2)
                        hiddenStr = hiddenStr + ' ' + deal.salesPerson2?.firstName + ' ' + deal.salesPerson2?.lastName;
                    if (deal.financePerson1)
                        hiddenStr = hiddenStr + ' ' + deal.financePerson1?.firstName + ' ' + deal.financePerson1?.lastName;
                    if (deal.financePerson2)
                        hiddenStr = hiddenStr + ' ' + deal.financePerson2?.firstName + ' ' + deal.financePerson2?.lastName;
                    hiddenStr = hiddenStr + ' ' + customer?.customerNumber;
                    appointments[i]["hiddenCol"] = hiddenStr;
                
                }
	        	 return appointments;
            }
	        return []
	};



    const getResult = (id) => {
        let item = masterDropdownValues.appointmentResult.filter(x => x.key === id);
        if (item.length === 1) {
            return item[0].text;
        }
        return '';
    };

    const getSalesPerson = (salesPerson) => {
        if (salesPerson) {
            return salesPerson?.firstName + ' ' + salesPerson?.lastName;
        }
        return '';
    };

    const appointmentList =(isFilterApplied)=>{       
	     const formData = {
                page: isFilterApplied ? statePageNumber : pages,
                limit,
                sort: sortOrder === 1 ? 'ASC' : 'DESC',
                column: sortField,
                locationId:locationFilter?locationFilter:0,
                fromAppointmentDate: logDateFromFilter ? moment(logDateFromFilter).format('YYYY-MM-DD'):'',
                toAppointmentDate: logDateToFilter ? moment(logDateToFilter).format('YYYY-MM-DD') : '',
                search: search
            };
            setFilters(formData);
            if (isFilterApplied && statePageNumber > 1) {
                 setStatePageNumber(1);
            }
            dispatch<any>(handleGetAppointmentList({
                formData,
                callback: (response) => {
                    if (response) {
                        setTotalRecords(response.totalItems);
                        const appointmentData = handlePopulateAppointments(response.results);
                        setAppointmentData(appointmentData);
                    } else {
                        setTotalRecords(0);
                        setcommonServerError('Failed to Fetch the Data.');
                    }
                }
            }));
	}


    useEffect(() => {
        setSortOrder(1);
        setGLFilter(null);
        setSortField('appointmentTime');
        setLogDateFromFilter(new Date(todaydate));
        setlogDateToFilter(new Date(todaydate));
        if (user && user.auths && !isUserMaster(user.roles)) {
            setCredentials(getModulePermissions(user.auths, credentialModuleName));
        }
        dispatch<any>(handleGetLocations())
        //setLocationFilter(user.primaryLocation.id)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onPageChange = (event) => {
        setCurrentPage(event.first);
        setPages(event.page + 1);
        setLimit(event.rows);
    }

    const footer = (
        <>
            <Paginator first={currentPage} rows={limit} totalRecords={totalRecords} rowsPerPageOptions={[25, 50, 100]} onPageChange={onPageChange}></Paginator>
        </>
    );

    

   const handleColumnSort = (e) => {
		setSortField(e.sortField);
		setSortOrder(e.sortOrder);
	}

	const getAppointment = (isFilterApplied = false) => {
        setcommonServerError('');
        if (statesFlag && userProfileLoadingFlag) {
             appointmentList(isFilterApplied)
        }
    }

    useEffect(() => {
            if (statePageNumber > 1) {
                setPages(statePageNumber);
            } else {
                setPages(1);
                setCurrentPage(0);
            }
        getAppointment(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search,locationFilter,logDateFromFilter,logDateToFilter,statesFlag,userProfileLoadingFlag]);

    useEffect(() => {
        getAppointment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limit, pages, sortOrder, sortField]);

	const handleResetWorkbook = () => {   
        setGLFilter("");
        setLocationFilter(primaryLocation);
        setLogDateFromFilter(new Date(todaydate));
        setlogDateToFilter(new Date(todaydate));
        setSortField('appointmentTime');
        setSortOrder(-1);
        setLimit(25);
        setPages(1);
        //if (primaryLocation) {
        //    const results = appointments.filter(x => x.deal.location.id === primaryLocation);
        //    setAppointmentData(results);
        //} else {
        //    setAppointmentData(appointments);
        //}
    };

    const exportExcel = () => {
        const formData = { ...filters };
        formData.page = 1;
        formData.limit = 10000;
        dispatch<any>(handleGetAppointmentList({
            formData,
            callback: (response) => {
                if (response) {
                    if (response && response.results) {
                        let list = response.results
 
                                   const exportData = list.map((item) =>
                                   
				                     ({
									 "Appointment Date Time": moment(item.appointmentTime).local().format('MM/DD/YY hh:mm a'),
                                     'Sales Person 1': item.deal.salesPerson1 ?getSalesPerson(item.deal.salesPerson1):"",
                                     'Deal Number': item.deal.dealNumber,
                                     'Comments': item.appointmentPurpose,
                                     'Customer Name': item.deal.customer.businessName ? item.deal.customer.businessName:(item.deal.customer.firstName + ' ' + item.deal.customer.lastName),
                                     'Customer Email': item.deal.customer.email,
                                     'Customer Phone': item.deal.customer.phoneNumber,
                                     'Confimed By':  item.employee ? item.employee.firstName + ' ' + item.employee.lastName : '',
                                     'Mgr Notes': item.appointmentNotes,
                                     'Result': item.appointmentResult ? getResult(item.appointmentResult) : ''
				                   }));
				                   
			                       import('xlsx').then(xlsx => {
                                       const worksheet = xlsx.utils.json_to_sheet(exportData);
                                       const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                                       const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                                       saveAsExcelFile(excelBuffer, 'appointment-workbook');
                                   });
                        
                    }
                } else {
                    setTotalRecords(0);
                    setcommonServerError('Failed to Fetch the Data.');
                }
            }
        }));


    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    }

    //Datatable Templates
	const header = (
		<>  

		{isMobile ?
		<div>
                    <Row>
                        <Col>
                              <div className="locationDropPosition">
			                  	{/*<TextField
			                  		value={glFilter}
			                  		type="search"
			                  		label="Search Appraisals"
			                  		className="ownerSearchText"
			                  		onChange={(e) => handleFirstNameFilter(e)}
			                  	/>*/}
								  <label className="lbl-text">Search</label>
                                  <div className="ms-TextField-fieldGroup debounce-input-group">
                                      <DebounceInput
                                          minLength={1}
                                          className="ms-TextField-field"
                                          value={search}
                                          debounceTimeout={750}
                                          onChange={(e) => handleSearchChange(e)} />
                                  </div>
			                  </div>
			         	</Col>
                        <Col>
                            <div className="locationDropPosition">
                                <label className="lbl-text" style={{ paddingBottom: "0px" }}>Location</label>
                                <Dropdown
                                    id="locationId"
                                    placeholder=""
                                    value={locationFilter}
                                    options={cityDealerList}
                                    onChange={onLocationChange}
                                    optionLabel="legalName"
                                    optionValue="id"
                                    appendTo="self"
                                    className="custom-p-dropdown"
                                    filter={false}
                                    resetFilterOnHide={true}
                                />
                            </div>
                        </Col>

                    </Row>
                    <Row style={{ width: "auto" }} >
                        <Col>
                            <div className="date-filter-section">
                                <div className="table-header">
                                    <div className="ms-TextField-wrapper">
                                        <label className="lbl-text">Appointment Date</label>
                                        <div className="ms-TextField-fieldGroup mask-FieldGroup date-filter">
                                            <Calendar
                                                id="fromLogDate"
                                                style={{ width: "100%" }}
                                                value={logDateFromFilter}
                                                showIcon
                                                onChange={(e) => handleFromLogDateChange(e)}
                                                monthNavigator
                                                yearNavigator
                                                yearRange={yearRange}
                                                maxDate={logDateToFilter}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <label className="lbl-text" style={{ margin: "30px 10px 0px" }}>To</label>
                                <div className="table-header">
                                    <div className="ms-TextField-wrapper">
                                        <label className="lbl-text">&nbsp;</label>
                                        <div className="ms-TextField-fieldGroup mask-FieldGroup date-filter">
                                            <Calendar
                                                id="toLogDate"
                                                style={{ width: "100%" }}
                                                value={logDateToFilter}
                                                showIcon
                                                onChange={(e) => handleToLogDateChange(e)}
                                                monthNavigator
                                                yearNavigator
                                                yearRange={yearRange}
                                                minDate={logDateFromFilter}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col className=" employeeeSearchLabelText" style={{ marginTop: "32px", maxWidth: "40%" }} >
                            <PrimaryButton style={{ float: "right" }}
                                onClick={handleResetWorkbook}
                            >
                                Reset
                               </PrimaryButton>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="display-row" style={{ marginTop: "15px" }}>
                            {
                                totalRecords !== null && <label className="lbl-text">Record Count: {totalRecords}</label>
                            }
                            <Link className="workbook-export-btn-mob" color="inherit" onClick={exportExcel} data-pr-tooltip="XLS"  >
                                Export to Excel
						    </Link>
                        </Col>
                    </Row>
		</div>
        :
		<div>
            <div>
		        <Row>
		            <Col md={10}>
			         <Row>
			             <Col  md={3}>
			                  <div className="table-header employeeeSearchLabelText">
			                  	{/*<TextField
			                  		value={glFilter}
			                  		type="search"
			                  		label="Search Appraisals"
			                  		className="ownerSearchText"
			                  		onChange={(e) => handleFirstNameFilter(e)}
			                  	/>*/}
								  <label className="lbl-text">Search</label>
                                  <div className="ms-TextField-fieldGroup debounce-input-group">
                                      <DebounceInput
                                          minLength={1}
                                          className="ms-TextField-field"
                                          value={search}
                                          debounceTimeout={750}
                                          onChange={(e) => handleSearchChange(e)} />
                                  </div>
			                  </div>
			         	</Col>
			         	<Col  md={3}>
						  <div className="dd-control">
			                  <label className="lbl-text">Location</label>
                              <Dropdown
                                    id="locationId"
                                    placeholder=""
                                    value={locationFilter}
                                    options={cityDealerList}
                                    onChange={onLocationChange}
                                    optionLabel="legalName"
                                    optionValue="id"
                                    appendTo="self"
                                    className="custom-p-dropdown write-ups-location-dd"
                                    filter={ false}
                                    resetFilterOnHide={true}
                                />
							</div>
			         	</Col>
                        <Col md={4}>
                            <div className="date-filter-section">
			                    <div className="table-header">
						            <div className="ms-TextField-wrapper">
						                 <label className="lbl-text">Appointment Date</label>
						                 <div className="ms-TextField-fieldGroup mask-FieldGroup date-filter">
                                            <Calendar
                                                id="fromLogDate"
                                                style={{ width: "100%" }}
                                                value={logDateFromFilter}
                                                showIcon
                                                onChange={(e) => handleFromLogDateChange(e)}
                                                monthNavigator
                                                yearNavigator
                                                yearRange={yearRange}
                                                maxDate={logDateToFilter}
						                    />
						                 </div>
						            </div>
                                </div>
                                <label className="lbl-text" style={{margin:"30px 10px 0px"}}>To</label>
                                <div className="table-header">
                                    <div className="ms-TextField-wrapper">
                                    <label className="lbl-text">&nbsp;</label>
                                        <div className="ms-TextField-fieldGroup mask-FieldGroup date-filter">
                                            <Calendar
                                                id="toLogDate"
                                                style={{ width: "100%" }}
                                                value={logDateToFilter}
                                                showIcon
                                                onChange={(e) => handleToLogDateChange(e)}
                                                monthNavigator
                                                yearNavigator
                                                yearRange={yearRange}
                                                minDate={logDateFromFilter}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
			         	</Col>
                        <Col  md={1} >
						   <div className="table-header employeeeSearchLabelText" style={{marginTop:"24px"}}>
			                   <PrimaryButton
							      onClick={handleResetWorkbook}
							   >
                                   Reset
                               </PrimaryButton>
						   </div>
							  
			         	</Col>

			         </Row>
				</Col>
		            <Col>
				    </Col>
		        </Row>
            </div>
            <div className="display-row total-export-row">
                <div>
                    {
                        totalRecords !== null && <label className="lbl-text">Record Count: {totalRecords}</label>
                    }
                </div>
                <div>
                    <Link className="workbook-export-btn" color="inherit" onClick={exportExcel} data-pr-tooltip="XLS"  >
                        Export to Excel
		            </Link>
                </div>
            </div>
		</div>}

		</>
	);


    const dateBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Appointment Date Time</span>
                {rowData.appointmentTime}
            </React.Fragment>
        );
    };

    const salesPersonBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Sales Person 1</span>
                {rowData.salesPerson1}

            </React.Fragment>
        );
    };

    const dealNumberBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Deal Number</span>
                {rowData.dealNumber}

            </React.Fragment>
        );
    };

    const purposeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Appointment Purpose</span>
                {rowData.appointmentPurpose}

            </React.Fragment>
        );
    };

    const custNameBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Customer Name</span>
                {rowData.customer}

            </React.Fragment>
        );
    };

    const custEmailBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Customer Email</span>
                {rowData.customerEmail}

            </React.Fragment>
        );
    };

    const custPhoneBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Customer Phone</span>
                {rowData.customerPhone}

            </React.Fragment>
        );
    };

    const confirmedByBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Confimed By</span>
                {rowData.confirmedBy}

            </React.Fragment>
        );
    };

    const notesBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Mgr Notes</span>
                {rowData.appointmentNotes}

            </React.Fragment>
        );
    };    

    const resultBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Result</span>
                {rowData.appointmentResult}

            </React.Fragment>
        );
    };    

    const settingBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {/*<span className="p-column-title" style={{ float: "left" }}>Actions</span>*/}
                {credentials && user.roles && (
                    <EditMoreActionsSubmenu
                        modulePermissions={credentials}
                        itemId={rowData.id}
                        onEdit={(appointmentId) => handleEditAppointment(appointmentId)}
                    />
                )}
            </React.Fragment>
        );
    };

    const handleEditAppointment = (id) => {
        const selectedApp = appointmentData.find(x => x.id === id);
        if (selectedApp) {
            handleNavigateToAppointment(selectedApp.deal.id,id);
        }
    };

    const handleRowClick = (event) => {
        let target = event.originalEvent.target;
        if (target.nodeName === 'TD' && target.hasChildNodes() && target.lastElementChild.nodeName === 'BUTTON') {
            target?.lastElementChild?.lastElementChild?.firstElementChild.click();
        } else {

            handleNavigateToAppointment(event.data.deal.id, event.data.id);
        }
    };


    const handleNavigateToAppointment = (dealId,id) => {
        const state = { 
            search,
            pathfrom: '/appointments',
            tabIndex: 1,
            productId: `${id}`,
            workbookName: 'appointments',
            sortOrder,
            sortField,
            pages,
            limit,
            logDateFromFilter,
            logDateToFilter,
            locationFilter }
        navigate(`/${dealId}/dealtracker`, { state });
    }

    useEffect(() => {
        if (serverError) {
            if (serverError.detail) {
                setcommonServerError(serverError.detail);
            } else {
                setcommonServerError('Something went wrong');
            }
            window.scrollTo(0, 0);
        } else {
            setcommonServerError(null);
        }
    }, [serverError]);
    
    useEffect(() => {         
        setStatesFlag(true);
        const stateVal: any = location?.state
        if (stateVal?.search) {
            setGLFilter(stateVal.search)
        }
        if (stateVal?.fromKeymetrics) {
            
            setLocationFilter(stateVal?.locationFilter);
            setLogDateFromFilter(new Date(stateVal?.filterDate));
            setlogDateToFilter(new Date(stateVal?.filterDate));
        } 

        if (stateVal?.locationFilter) {
            setLocationFilter(stateVal?.locationFilter);
        }

        if(primaryLocation === 0 && stateVal?.locationFilter === 0){
            setLocationFilter(0);
        }
        if (stateVal?.logDateFromFilter) {
            setLogDateFromFilter(new Date(stateVal.logDateFromFilter));
        }

        if (stateVal?.logDateToFilter) {
            setlogDateToFilter(new Date(stateVal.logDateToFilter));
        }

        if (stateVal?.sortField) {
            setSortField(stateVal.sortField);
            setSortOrder(stateVal.sortOrder);
            setPages(stateVal.pages);
            setLimit(stateVal.limit);
            if (stateVal.pages > 1) {
                setStatePageNumber(stateVal.pages);
                setCurrentPage((stateVal.pages - 1) * stateVal.limit);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [location]);


    return (
        isKarlProfileType ? <>
            <Stack styles={container} tokens={{ childrenGap: 10 }}>
                <Stack
                    horizontal
                    verticalAlign="center"
                    horizontalAlign="space-between"
                    className="loc_btn_par_con"
                >

                    <Row>
                        <Col className="alignHeaders">
                            <CustomFontText className="pageTitleFont pageName pageHeaderFont">Appointments</CustomFontText>
                        </Col>
                    </Row>
                </Stack>
                {
                    commonServerError ?
                        <div>
                            <p className="genericErrorColor"><span>{commonServerError}</span></p>
                        </div> : null
                }
                <div className="datatable-filter-demo noMaxWidthTable"> {/* locations */}
                    <div className="lazy-loading-workbook card mouse-hover workbookLocationPlaceHolder">
                        <DataTable
                            value={appointmentData}
                            paginator={false}
                            header={header}
                            footer={footer}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={handleColumnSort}
                            lazy
                            //rows={25}
                            className="p-datatable-customers"
                            //rowsPerPageOptions={[25, 50, 100]}
                            emptyMessage="No appointments found."
                            onRowClick={(event) => handleRowClick(event)}>
                            <Column sortable field="appointmentTime" sortField="appointmentTime" header="Appointment Date Time" body={dateBodyTemplate} />
                            <Column sortable field="salesPerson1" header="Sales Person 1" body={salesPersonBodyTemplate} />
                            <Column sortable field="dealNumber" header="Deal Number" body={dealNumberBodyTemplate} />
                            <Column sortable field="appointmentPurpose" header="Comments" body={purposeBodyTemplate} />
                            <Column sortable field="customer" header="Customer Name" body={custNameBodyTemplate} />
                            <Column sortable field="customerEmail" header="Customer Email" body={custEmailBodyTemplate} />
                            <Column sortable field="customerPhone" header="Customer Phone" body={custPhoneBodyTemplate} />
                            <Column sortable field="confirmedBy" header="Confimed By" body={confirmedByBodyTemplate} />
                            <Column sortable field="appointmentNotes" header="Mgr Notes" body={notesBodyTemplate} />
                            <Column sortable field="appointmentResult" header="Result" body={resultBodyTemplate} />
                            <Column field="Settings" style={{ width: '5em' }} header="Actions" body={settingBodyTemplate} />
                        </DataTable>
                        
                    </div>
                </div>
            </Stack>
        </> : null
    );
};
